import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/pro-regular-svg-icons";

// // // //

export function NoResultsState() {
    return (
        <div className="flex flex-col items-center justify-center gap-2 px-6 py-16 text-center">
            <div className="flex size-11 items-center justify-center rounded-full bg-muted">
                <FontAwesomeIcon
                    icon={faMagnifyingGlass}
                    className="size-5 text-muted-foreground"
                />
            </div>
            <p className="text-sm font-medium text-foreground">
                No clients found
            </p>
            <p className="text-sm text-muted-foreground">
                Try adjusting your search or filters.
            </p>
        </div>
    );
}
